import type { FaireProductEntity } from "../../entity_types/product";

export const p_ck8nx53z2t: FaireProductEntity = {
  token: "p_ck8nx53z2t",
  type: "product",
  name: "Love You Mom Gift Candle",
  brandToken: "b_5m0xhjob5o",
  brandName: "Candlefy",
  imageUrl:
    "https://cdn.faire.com/fastly/d4377ee40550b141b782123b5322ead169ce48d462642c0e25b0e947a4b0e85f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5cae7c3098a93ced94848a9ebd572754577a86f69ea545dcda5de5df44be358a.jpeg",
  ],
  priceDollars: 10.99,
  description:
    "Love You Mom Gift Candle – Wild Rose\n\nA modern, giftable candle designed for Mother’s Day and year-round gifting.\n\nInspired by appreciation and everyday moments, this scent blends French rose and black currant with smooth sandalwood to create a soft, balanced atmosphere that feels warm, comforting, and widely appealing.\n\nHand-poured in California using a coconut apricot wax blend for a clean, even burn and strong scent throw. Poured into our signature amber apothecary jar with a gold lid for a timeless, gift-ready presentation.\n\nScent Profile\n\nFrench Rose • Sandalwood • Black Currant\n\nWhy Retailers Love It\n\nPart of our bestselling giftable candle collection\nStrong seasonal and year-round sales (Mother’s Day)\nSoft floral scent with broad appeal\nEasy to merchandise and gift\n\nDetails\n\n8 oz amber apothecary jar\nApprox. 45–60 hour burn time\nCoconut apricot wax blend\nPhthalate-free scents\nHand-poured in California\nMade in USA",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:33.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
